import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Component } from "preact";
import { route } from "preact-router";
import Page from "../../../../services/page-data-feed";
import { HelpIcon, HomeIcon, TicketIcon } from "../../utils/icons";
import Ticket from "../../utils/ticket-logic";

const CasinoIcon = (props) => (
	<svg class={"fill-current " + (props.class || "")} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zm0 2v12h16V6H4zm2 2h2v2H6V8zm4 0h2v2h-2V8zm4 0h2v2h-2V8zM6 12h2v2H6v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2z"/>
	</svg>
);

export function SportIcon({sport}) {
	return <span class={"text-2xl sporticon sp_1"}></span>
}

const NavItem = ({icon, label, href, onClick, isActive, badge}) => {
	const handleClick = (e) => {
		e.preventDefault();
		
		if (onClick) {
			onClick(e);
		} else if (href) {
			route(href);
		}
	};

	return (
		<a 
			href={href || "javascript:void(0);"} 
			onClick={handleClick}
			class={`border-r border-harif-950 grow flex flex-col items-center justify-center h-full transition-all duration-200 ${isActive ? 'text-custom-orange bg-harif-900' : 'text-white hover:text-custom-orange hover:bg-harif-950'}`}
		>
			<div class="relative group">
				<div class="hover:animate-bounce transition-transform duration-200">
					{icon}
				</div>
				{badge && (
					<div class="absolute -top-6 -right-[.8rem] bg-custom-orange text-black text-xl rounded-full w-12 h-12 flex items-center justify-center font-bold shadow-md">
						{badge}
					</div>
				)}
			</div>
			<span class="text-xs mt-1 text-center">{label}</span>
		</a>
	);
};

export default class MobileBottomNav extends Component {
	componentWillMount() {
		Ticket.registerBetslipRenderCallback(this.ticketListener = () => this.setState({}));
	}
	
	componentDidUnmount() {
		if (this.ticketListener) {
			Ticket.registerBetslipRenderCallback(null);
		}
	}

	render() {
		const currentPath = window.location.pathname;
		const isTicketOpen = Page.isMobileTicketOpen();
		
		const betslipCount = Ticket.countOdds();
		
		return (
			<nav class="fixed bottom-0 left-0 right-0 z-50 bg-harif-800 border-t border-harif-950">
				<div class="flex justify-around items-center h-16">
					<NavItem 
						icon={<HomeIcon class="w-6 h-6 fill-current" />}
						label={<Trans>Home</Trans>}
						href="/home"
						isActive={currentPath === '/home' || currentPath === '/'}
					/>
					<NavItem 
						icon={<SportIcon class="w-6 h-6 fill-current" />}
						label={<Trans>Sports</Trans>}
						href="/prematch"
						isActive={currentPath.startsWith('/prematch') || currentPath.startsWith('/live')}
					/>
					<NavItem 
						icon={<TicketIcon class="w-6 h-6 fill-current" />}
						label={<Trans>Betslip</Trans>}
						onClick={() => {
							// Navigate to base URL when betslip is clicked
							if (!Page.isMobileTicketOpen()) {
								window.location.hash = '#betslip';
								Page.toggleMobileTicket();
							} else {
								window.history.back()
								Page.toggleMobileTicket();
							}
							Page.rerender();
						}}
						isActive={isTicketOpen}
						badge={betslipCount > 0 ? betslipCount : null}
					/>
					<NavItem 
						icon={<CasinoIcon class="w-6 h-6 fill-current" />}
						label={<Trans>Casino</Trans>}
						href="/virtual"
						isActive={currentPath.startsWith('/virtual')}
					/>
					<NavItem 
						icon={<HelpIcon class="w-6 h-6 fill-current" />}
						label={<Trans>Help</Trans>}
						href="/contacts"
						isActive={currentPath.startsWith('/contacts')}
					/>
				</div>
			</nav>
		);
	}
}
